module.exports = __webpack_public_path__ + "img/1.cfbf39d9.jpeg";